import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { Subject, takeUntil } from 'rxjs';
import { Menu } from '../../models/menu.model';
import { PermissionActions } from 'src/app/modules/permissions/store/permission.actions';
import { PermissionSelectors } from 'src/app/modules/permissions/store/premission.selector';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterContentChecked, OnDestroy {
  menus$: Menu[] = [];
  private unsubscriber$ = new Subject<void>();


  constructor(
    public store: Store,
    private actions$: Actions,
    private router: Router,
    private cdref: ChangeDetectorRef
  ) { 
    this.store.dispatch(PermissionActions.GetPermissions);
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }

  ngAfterContentChecked(): void {
    this.listenMenu();
    this.cdref.detectChanges();
  }

  isActiveNavItemByPath(path: string ) {
    return this.router.isActive(path, false);
  }

  onOpcionClick(event) {
    const parentNode = event.target.parentNode;
    const lastElementChild = event.target.parentNode?.lastElementChild;

    parentNode.classList.toggle("opened");
    lastElementChild.classList.toggle("visible");
  }

  private listenMenu() {
    this.actions$.pipe(ofActionSuccessful(PermissionActions.GetPermissionsSuccess),
    takeUntil(this.unsubscriber$))
    .subscribe(() => {
      this.menus$ = this.store.selectSnapshot(PermissionSelectors.getMenu);
      this.unsubscriber$.next();
      });
  }
}
